// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__39HxV","Menu":"Header_Menu__1YPbb"};